export const reel4 = {
    id: 'reel-4',
    schemaVersion: 2,
    covers: 'The most copy of any format: a hook and many short statements in quick succession. Suits a dense explainer or a rapid myth-busting run.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 583,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 11],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 4.733,
                            transition: 'fade',
                        },
                        {
                            atSec: 6.6,
                            transition: 'cut',
                        },
                        {
                            atSec: 8.3,
                            transition: 'cut',
                        },
                        {
                            atSec: 10.633,
                            transition: 'cut',
                        },
                        {
                            atSec: 12.133,
                            transition: 'cut',
                        },
                        {
                            atSec: 12.6,
                            transition: 'fade',
                        },
                        {
                            atSec: 13.8,
                            transition: 'cut',
                        },
                        {
                            atSec: 14.1,
                            transition: 'cut',
                        },
                        {
                            atSec: 14.333,
                            transition: 'cut',
                        },
                        {
                            atSec: 15.667,
                            transition: 'cut',
                        },
                        {
                            atSec: 16.433,
                            transition: 'fade',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'scene-0',
                duration: {
                    kind: 'fixed',
                    frames: 128,
                },
                start: {
                    at: 'frame',
                    value: 10,
                },
                placement: {
                    anchor: 'center',
                    x: 0.497,
                    y: 0.526,
                    width: 0.929,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 87.9,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 42,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 87.9,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            align: 'center',
                            entranceDurationFrames: 46,
                            motion: {
                                delayFrames: 42,
                            },
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook3',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 83.6,
                                fontWeight: 200,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 34,
                            align: 'center',
                            motion: {
                                delayFrames: 3,
                            },
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-1',
                duration: {
                    kind: 'fixed',
                    frames: 45,
                },
                start: {
                    at: 'frame',
                    value: 145,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.501,
                    y: 0.831,
                    width: 0.463,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 62.1,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            align: 'center',
                            entranceDurationFrames: 9,
                            motion: {
                                delayFrames: 3,
                            },
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-2',
                duration: {
                    kind: 'fixed',
                    frames: 45,
                },
                start: {
                    at: 'frame',
                    value: 190,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.499,
                    y: 0.809,
                    width: 0.426,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement3',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement4',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                            motion: {
                                delayFrames: 5,
                            },
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement10',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                fontRef: 'jost',
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            motion: {
                                delayFrames: 5,
                            },
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-2b',
                duration: {
                    kind: 'fixed',
                    frames: 45,
                },
                start: {
                    at: 'frame',
                    value: 237,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.5,
                    y: 0.856,
                    width: 0.5,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'statement11',
                            },
                            required: true,
                        },
                    },
                    style: 'display',
                    styleOverride: {
                        colorRole: 'onPrimary',
                        textTransform: 'uppercase',
                        fontSize: 60,
                        fontWeight: 400,
                        fontRef: 'jost',
                        whiteSpace: 'nowrap',
                    },
                    entrance: 'letter-flip',
                    entranceDurationFrames: 9,
                    align: 'center',
                },
            },
            {
                kind: 'group',
                id: 'scene-3',
                duration: {
                    kind: 'fixed',
                    frames: 45,
                },
                start: {
                    at: 'frame',
                    value: 285,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.5,
                    y: 0.858,
                    width: 0.626,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement5',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 62.1,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement6',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            align: 'center',
                            entranceDurationFrames: 9,
                            motion: {
                                delayFrames: 5,
                            },
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-4',
                duration: {
                    kind: 'fixed',
                    frames: 50,
                },
                start: {
                    at: 'frame',
                    value: 328,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.5,
                    y: 0.838,
                    width: 0.73,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement7',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement8',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 62.1,
                                fontWeight: 400,
                                whiteSpace: 'nowrap',
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                            motion: {
                                delayFrames: 12,
                            },
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-5',
                duration: {
                    kind: 'fixed',
                    frames: 45,
                },
                start: {
                    at: 'frame',
                    value: 375,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.49,
                    y: 0.797,
                    width: 0.793,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement9',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 62.1,
                                fontWeight: 400,
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement12',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 60,
                                fontWeight: 400,
                                fontRef: 'jost',
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            motion: {
                                delayFrames: 13,
                            },
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-6',
                duration: {
                    kind: 'fixed',
                    frames: 73,
                },
                start: {
                    at: 'frame',
                    value: 428,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.501,
                    y: 0.851,
                    width: 0.677,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'close',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 62.1,
                                fontWeight: 300,
                                fontRef: 'jost',
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'line',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 62.1,
                                fontWeight: 300,
                                fontRef: 'jost',
                            },
                            entrance: 'letter-flip',
                            entranceDurationFrames: 9,
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'card-0',
                start: {
                    at: 'frame',
                    value: 493,
                },
                duration: {
                    kind: 'fixed',
                    frames: 90,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#120D07',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                        adoptLogoScrim: true,
                    },
                },
            },
            {
                kind: 'group',
                id: 'brand-card-0',
                start: {
                    at: 'frame',
                    value: 504,
                },
                duration: {
                    kind: 'fixed',
                    frames: 79,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5079,
                    y: 0.3692,
                    width: 0.62,
                },
                root: {
                    kind: 'logo',
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    width: 1,
                    entrance: 'fade-in',
                    entranceDurationFrames: 20,
                },
            },
            {
                kind: 'rect',
                id: 'bar-offer',
                start: {
                    at: 'frame',
                    value: 503,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5007,
                    y: 0.5805,
                    width: 0.7986,
                    height: 0.0625,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-offer',
                start: {
                    at: 'frame',
                    value: 503,
                },
                duration: {
                    kind: 'fixed',
                    frames: 80,
                },
                placement: {
                    anchor: 'center',
                    x: 0.498,
                    y: 0.5761,
                    width: 0.78,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'jost',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 400,
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                                letterSpacing: 0,
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'jost',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 400,
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                                letterSpacing: 0,
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-cta',
                start: {
                    at: 'frame',
                    value: 511,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.4993,
                    y: 0.6375,
                    width: 0.7986,
                    height: 0.0234,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-cta',
                start: {
                    at: 'frame',
                    value: 511,
                },
                duration: {
                    kind: 'fixed',
                    frames: 72,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4986,
                    y: 0.6374,
                    width: 0.9,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'cta',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'jost',
                                textTransform: 'none',
                                fontSize: 34.4,
                                fontWeight: 400,
                                lineHeight: 1.1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-tagline',
                start: {
                    at: 'frame',
                    value: 516,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.7656,
                    width: 0.9138,
                    height: 0.0516,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-tagline',
                start: {
                    at: 'frame',
                    value: 516,
                },
                duration: {
                    kind: 'fixed',
                    frames: 67,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4996,
                    y: 0.7652,
                    width: 0.86,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'jost',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 400,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'jost',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 400,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 18,
            description: 'Line 1 of three, opening the ONE sentence this whole format is. Addressed directly to clients. Source shape: "CLIENTS PLEASE".',
        },
        hook2: {
            type: 'text',
            maxChars: 18,
            description: 'Line 2, continuing that sentence mid-flow. Source shape: "DON\'T BE AFRAID TO".',
        },
        hook3: {
            type: 'text',
            maxChars: 19,
            description: 'Line 3, which leaves the sentence DELIBERATELY UNFINISHED on an ellipsis — every statement below completes it. Source shape: "ASK FOR...". Do not finish the thought here.',
        },
        statement: {
            type: 'text',
            maxChars: 29,
            description: 'A NOUN PHRASE completing the sentence `hook3` leaves open — one thing a client may ask for. Not a sentence, not a claim, no verb of its own. Source shape: "A SILENT" (continuing into `statement2`).',
        },
        statement2: {
            type: 'text',
            maxChars: 29,
            description: 'Second line of that first item, where it needs two. Source shape: "APPOINTMENT".',
        },
        statement3: {
            type: 'text',
            maxChars: 27,
            description: 'The next thing a client may ask for, line 1 — still completing `hook3`. Source shape: "TO TURN THE".',
        },
        statement4: {
            type: 'text',
            maxChars: 27,
            description: 'Line 2 of that item. Source shape: "HEATED".',
        },
        statement10: {
            type: 'text',
            maxChars: 29,
            description: 'Line 3 of that item, where it needs three. Source shape: "BLANKET UP/DOWN".',
        },
        statement11: {
            type: 'text',
            maxChars: 29,
            description: 'A short item that fits on ONE line. Source shape: "A PHONE CHARGER".',
        },
        statement5: {
            type: 'text',
            maxChars: 26,
            description: 'The next thing, line 1. Source shape: "CLARIFICATION ON".',
        },
        statement6: {
            type: 'text',
            maxChars: 27,
            description: 'Line 2 of it. Source shape: "HOMECARE ADVICE".',
        },
        statement7: {
            type: 'text',
            maxChars: 27,
            description: 'The next thing, line 1. Source shape: "TO ADJUST THE MUSIC".',
        },
        statement8: {
            type: 'text',
            maxChars: 26,
            description: 'Line 2 of it. Source shape: "VOLUME".',
        },
        statement9: {
            type: 'text',
            maxChars: 50,
            description: 'The last thing, line 1 — the source saves the most substantial ask for here. Source shape: "TO DISCUSS A TAILORED".',
        },
        statement12: {
            type: 'text',
            maxChars: 22,
            description: 'Line 2 of it. Source shape: "TREATMENT PLAN".',
        },
        close: {
            type: 'text',
            maxChars: 27,
            description: 'Steps OUT of the list and resolves the sentence in the clinic\'s own voice, line 1 — what all of it adds up to. Source shape: "AT BEAUTY ONE, EVERY".',
        },
        line: {
            type: 'text',
            maxChars: 43,
            description: 'Line 2 of the resolution, landing on the client. Source shape: "DETAIL IS ABOUT YOU".',
        },
        offer1: {
            type: 'text',
            maxChars: 34,
            description: "The first of two lines naming something CONCRETE the viewer can take up — a consultation, a patch test, a named treatment, a specific package. Name the thing itself; 'our range of services' is not an offer. Set in italic sans, apart from the rest of the card.",
        },
        offer2: {
            type: 'text',
            maxChars: 34,
            description: 'The second offer line, completing the first rather than starting a new one — the condition, the timing, or what is included. The two lines are read together as one offer.',
        },
        cta: {
            type: 'text',
            maxChars: 46,
            description: "The end-card call to action: the single action to take, as a verb phrase — 'Book a consultation', 'Message us to check your suitability'. An instruction, not a slogan. May carry **bold** runs on the words that matter.",
        },
        tagline1: {
            type: 'text',
            maxChars: 30,
            description: "The first of two closing tagline lines — the clinic's standing promise, not anything specific to this treatment. May carry *italic* runs.",
        },
        tagline2: {
            type: 'text',
            maxChars: 30,
            description: 'The second tagline line, completing the first. The two are read as one phrase, so it must not restate line one.',
        },
    },
    structure: "ONE SENTENCE spread over seventeen boxes. `hook`, `hook2` and `hook3` open it and leave it deliberately UNFINISHED — the source is \"CLIENTS PLEASE / DON'T BE AFRAID TO / ASK FOR...\" — and every `statement` after it is a NOUN PHRASE completing that sentence: 'a silent appointment', 'a phone charger', 'to adjust the music volume'. They are not claims and not sentences; each one must read on directly from the hook. `close` and `line` step out and resolve it in the clinic's voice (\"At [clinic], every detail is about you\"). A statement that reads as a standalone benefit is WRONG however good it is.",
};
//# sourceMappingURL=reel-4.js.map